import React, {FC} from 'react';

import {createMandatoryContext} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {BaseEditorContext, createBaseEditorContext, CreateBaseEditorContextProps} from '../baseEditorContext';

/*
 * Types.
 */

export interface ServerEditorContext extends BaseEditorContext {}

interface CreateServerEditorContextProps extends CreateBaseEditorContextProps {}

/*
 * Context.
 */

export const [ServerEditorContext, useServerEditorContext] = createMandatoryContext<ServerEditorContext>();

export const ServerEditorContextProvider: FC<{context: ServerEditorContext}> = ({context, children}) => (
  <BaseEditorContext.Provider value={context}>
    <ServerEditorContext.Provider value={context}>{children}</ServerEditorContext.Provider>
  </BaseEditorContext.Provider>
);

export const createServerEditorContext = ({
  namespace,
  isEditing,
  hasExpressions,
  hasHighlightErrorsFlag,
  isReadOnly = false,
}: CreateServerEditorContextProps): ServerEditorContext => {
  const baseEditorContext = createBaseEditorContext({
    namespace,
    isEditing,
    isReadOnly,
    hasExpressions,
    hasHighlightErrorsFlag,
  });

  return {
    ...baseEditorContext,
  };
};
